export type MarketMapsKeys =
  | 'inStoreTraffic'
  | 'inMarketShoppers'
  | 'salesVolume'
  | 'listedUnits'
  | 'marketDaysSupply';

type MarketMapsDefs = Record<
  MarketMapsKeys,
  {
    title: string;
    message: string;
  }
>;

export const MARKET_MAPS_DEFS: MarketMapsDefs = {
  inStoreTraffic: {
    title: 'In-store shopper traffic',
    message: 'The number of new customers that visited a dealership in the last 30 days',
  },
  inMarketShoppers: {
    title: 'In-market shoppers',
    message: 'Shoppers that are actively looking to purchase a vehicle over the last 30 days.',
  },
  salesVolume: {
    title: 'Sales volume',
    message: 'The number of vehicles sold in the last 30 days',
  },
  listedUnits: {
    title: 'Listed units',
    message:
      'The inventory of vehicles available for purchase within the market in the last 30 days.',
  },
  marketDaysSupply: {
    title: 'Market days supply',
    message:
      'The estimated number of days it would take to sell the current inventory of vehicles at the current sales rate without adding new stock.',
  },
};
